import { SxProps, Theme, TypographyProps } from '@mui/material';

import { AttendanceGridSession } from './types';
import { SessionEnum } from 'libs/api/src/lib/generated/schooly-api-v1/data-contracts';

export const SESSION_ORDER: AttendanceGridSession[] = ['am', 'pm'];

export const WORKING_WEEK_LENGTH = 5;

/**
 * `include` for the group aggregate: ask for every tracking point, periods
 * included. The endpoint defaults to "am,pm" when the param is omitted.
 */
export const AGGREGATE_INCLUDE_ALL_POINTS = [SessionEnum.Am, SessionEnum.Pm, 'period'].join(',');
export const AGGREGATE_INCLUDE_AM_PM = [SessionEnum.Am, SessionEnum.Pm].join(',');

export const PERCENT_PRECISION = 1;

export const ATTENDANCE_PRIMARY_COL_FIELD = 'attendance-primary';

export const ATTENDANCE_ROW_HEIGHT = 42;

export const ATTENDANCE_DAY_COL_WIDTH = 88;

export const ATTENDANCE_SUBJECT_DAY_COL_WIDTH = 72;
export const ATTENDANCE_SUBJECT_VISIBLE_COLUMNS = 7;

export const ATTENDANCE_TRACKING_POINT_COL_WIDTH = 56;

export const getAttendanceDayColWidth = (view?: AttendanceViewConfig): number =>
  view?.dayColWidth ?? ATTENDANCE_DAY_COL_WIDTH;

export const ATTENDANCE_CSS_CLASSES = {
  gridContainer: 'attendanceGridContainer',
  primaryCell: 'attendancePrimaryCell',
  dayCell: 'attendanceDayCell',
  dayHeaderCell: 'attendanceDayHeaderCell',
  primaryHeaderCell: 'attendancePrimaryHeaderCell',
} as const;

export type AttendancePrimaryHeaderConfig = {
  variant: TypographyProps['variant'];
  sx?: SxProps<Theme>;
};

export type AttendanceViewConfig = {
  primaryColWidth: number;
  columnHeaderHeight: number;
  scrollArrowWidth: number;
  dayColWidth: number;
  primaryHeader: AttendancePrimaryHeaderConfig;
};

export const ATTENDANCE_GROUP_VIEW = {
  primaryColWidth: 318,
  columnHeaderHeight: 78,
  scrollArrowWidth: 32,
  dayColWidth: ATTENDANCE_DAY_COL_WIDTH,
  primaryHeader: { variant: 'h4', sx: { color: 'common.grey' } },
} as const satisfies AttendanceViewConfig;

export const ATTENDANCE_STUDENT_VIEW = {
  primaryColWidth: 260,
  columnHeaderHeight: 42,
  scrollArrowWidth: 32,
  dayColWidth: ATTENDANCE_DAY_COL_WIDTH,
  primaryHeader: { variant: 'h4', sx: { color: 'common.grey', mb: '0px !important' } },
} as const satisfies AttendanceViewConfig;

export const ATTENDANCE_SUBJECT_VIEW = {
  ...ATTENDANCE_GROUP_VIEW,
  primaryColWidth: 256,
  dayColWidth: ATTENDANCE_SUBJECT_DAY_COL_WIDTH,
} as const satisfies AttendanceViewConfig;

export const ATTENDANCE_TRACKING_POINTS_VIEW = {
  ...ATTENDANCE_STUDENT_VIEW,
  dayColWidth: ATTENDANCE_TRACKING_POINT_COL_WIDTH,
  primaryHeader: { ...ATTENDANCE_STUDENT_VIEW.primaryHeader, variant: 'body1' },
} as const satisfies AttendanceViewConfig;
